import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const negatives = ['This is not a random collection of grooming tips.', 'This is not a generic dog care book.', 'This is not a collection of disconnected worksheets.', 'And it is not another resource that leaves you with hours of preparation before you can actually use it.'];
const workflow = [{
  step: 'OPEN',
  detail: 'Open the system.'
}, {
  step: 'CHOOSE',
  detail: 'Choose the objective.'
}, {
  step: 'SEE',
  detail: 'Show the visual.'
}, {
  step: 'TEACH',
  detail: 'Teach the lesson.'
}];
const ease = [0.23, 1, 0.32, 1] as const;
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-blue-950 relative overflow-hidden" data-id="element-255" data-mp="140hazcnbk0b2">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-1 bg-orange-500" data-id="element-256" data-mp="142k9kl2jf1re" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-257" data-mp="2jjavrt9pkcu6">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease
      }} data-id="element-258" data-mp="2fel1g8up76bd">
          <p className="text-sm md:text-base font-semibold text-white/80 mb-4" data-id="element-259" data-mp="2gtqx1amrases">
            The Complete Dog Grooming Teaching System for Instructors Worldwide
          </p>
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight mb-4 text-white" data-id="element-260" data-mp="2pw05luygsbpj">
            DOG GROOMING INSTRUCTOR <span className="text-orange-500" data-id="element-261" data-mp="1t68zeygt903w">READY</span>
          </h2>
          <p className="text-base md:text-lg text-white font-semibold mb-1" data-id="element-262" data-mp="1x6jgb6655axj">
            A Complete 6-in-1 Visual Teaching System
          </p>
          <p className="text-base md:text-lg text-white/75 mb-10" data-id="element-263" data-mp="22548qjf5iqbf">
            6 Complete Volumes · Professional Grooming Techniques · 5 Professional Bonus Guides ·
            100% Visual
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-264" data-mp="19f5p53jq7le5">
          <motion.div initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease
        }} className="space-y-3 bg-white/5 p-6 rounded-2xl border border-white/15" data-id="element-265" data-mp="1ef9vw1uu11r6">
            {negatives.map(statement => <div key={statement} className="flex items-start gap-3" data-id="element-266" data-mp="2qldgvb31e5uq">
                <X className="text-red-400 shrink-0 mt-1" size={18} data-id="element-267" data-mp="2mih3byscszxn" />
                <p className="text-white/75 text-sm" data-id="element-268" data-mp="1yrl6uocydgk2">{statement}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease
        }} className="bg-white p-6 rounded-2xl border-2 border-orange-500" data-id="element-269" data-mp="1tuupzytbqgxl">
            <div className="flex items-start gap-3" data-id="element-270" data-mp="3j6wv81ixrldx">
              <Check className="text-blue-600 shrink-0 mt-1" size={20} data-id="element-271" data-mp="3e953b7iajz9q" />
              <p className="text-blue-950 font-medium text-base leading-relaxed" data-id="element-272" data-mp="3eb7rrn3spkcc">
                Dog Grooming Instructor Ready is a complete visual teaching system created
                specifically for instructors who want to plan less, explain grooming techniques
                more clearly, correct students more effectively and create stronger learning
                progressions.
              </p>
            </div>
          </motion.div>
        </div>

        <div className="mt-12" data-id="element-273" data-mp="9cah8jqp4lqq">
          <p className="text-white/80 text-sm font-semibold uppercase tracking-widest mb-5" data-id="element-274" data-mp="9c0xhdw8vath">
            The system follows a simple workflow
          </p>
          <ol className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-0" data-id="element-275" data-mp="3vrlohjhvvkjs">
            {workflow.map((item, index) => <li key={item.step} className="relative flex flex-col items-center px-2" data-id="element-276" data-mp="4j7sqq0s02he" data-mpi={index}>
                <span className="text-2xl md:text-3xl font-extrabold tracking-tight text-orange-500" data-id="element-277" data-mp="s924f49czl02">
                  {item.step}
                </span>
                <span className="text-sm text-white/80 mt-1" data-id="element-278" data-mp="34ketuihmyp71">{item.detail}</span>
                {index < workflow.length - 1 && <span className="hidden md:block absolute right-0 top-2 translate-x-1/2 text-2xl text-white/40" aria-hidden="true" data-id="element-279" data-mp="30ijpf54ervp1">
                    →
                  </span>}
              </li>)}
          </ol>
          <p className="mt-8 text-sm md:text-base font-bold tracking-widest text-white" data-id="element-280" data-mp="3o7cf4juft7b7">
            OPEN → CHOOSE → SEE → TEACH
          </p>
        </div>
      </div>
    </section>;
}